import React from 'react';
import {View} from 'react-native';
import {isNull} from 'lodash';
import {isEmpty} from 'lodash/fp';

import {ACTIVE} from '/enum/candidates.enum';

import {EmailAlreadyExistsBanner} from '../MergeBanner/EmailAlreadyExistsBanner';
import {ProfileAlreadyExistsBanner} from '../MergeBanner/ProfileAlreadyExistsBanner';
interface ClientDetails {
  [key: string]: any;
}
interface MergeBannerProps {
  accordionIcon: React.ReactElement | null;
  candidateId: string | null;
  flag: 'own' | 'outside' | '';
  popoverShow: () => void;
  clientDetails: ClientDetails | null;
  deleteCandidate: () => void;
  onMergePress: () => void;
  acceptBefore: string | null;
  status: string | null;
}

export const MergeBanner: React.FC<MergeBannerProps> = ({
  accordionIcon = null,
  candidateId = null,
  popoverShow = () => {},
  clientDetails = null,
  deleteCandidate = () => {},
  onMergePress = () => {},
  acceptBefore = null,
  status = null,
  flag = '',
}) => {
  return (
    <>
      {isNull(acceptBefore) && status === ACTIVE && (
        <View>
          {/* flag values own, outside */}
          {!isEmpty(clientDetails) && (
            <>
              {flag === 'outside' ? (
                <EmailAlreadyExistsBanner
                  popoverShow={popoverShow}
                  candidateId={candidateId}
                  deleteCandidate={deleteCandidate}
                />
              ) : (
                flag === 'own' && (
                  <ProfileAlreadyExistsBanner
                    clientDetails={{
                      ...clientDetails,
                      popoverShow,
                      candidateId,
                      deleteCandidate,
                      accordionIcon,
                    }}
                    onMergePress={onMergePress}
                  />
                )
              )}
            </>
          )}
        </View>
      )}
    </>
  );
};

export default MergeBanner;
